import {put, call, takeLatest, select} from 'redux-saga/effects';
import {waitFor} from '../helpers/saga.helper';
import recommendedApi from '../api/recommended.api';
import * as ActionTypes from '../actions/types.action';
import {
  getValidUSDate,
  processedGQLSearchResults,
} from '../helpers/data.helper';
import {getDeliveryDate} from '../helpers/search.helper';
import {getBearerHeader} from '../helpers/api.helper';

function* recommended(action) {
  try {
    const getAuth = state => state.auth;
    const getBranch = state => state.branch;
    const getBasket = state => state.basket;
    const getSettings = state => state.settings;
    let basket = yield select(getBasket);
    const settings = yield select(getSettings);
    const branch = yield select(getBranch);
    let storeToken = yield select(getAuth);
    const times = 5;
    const ms = 300;
    if (!basket) {
      basket = yield waitFor(getBasket, times, ms);
    }
    if (!storeToken) {
      storeToken = yield waitFor(getAuth, times, ms);
    }
    const headers = getBearerHeader(action.jjToken, storeToken);
    let params = {};
    const deliveryDate = getDeliveryDate(
      basket,
      action.fulfillmentDetails,
      settings
    );
    if (deliveryDate) {
      params = {deliveryDate: getValidUSDate(deliveryDate)};
    }
    params = Object.assign({}, params, {
      branch: action.branch || branch,
      itemId: action.itemId,
    });
    const results = yield call(
      recommendedApi.get,
      params,
      action.fullList,
      headers
    );
    yield put({
      type: ActionTypes.GET_RECOMMENDED_ITEMS_SUCCESS,
      recommendedItems: processedGQLSearchResults(
        results.data.lookupFrequentlyBoughtTogether.results
      ),
    });
  } catch (e) {
    yield put({
      type: ActionTypes.GET_RECOMMENDED_ITEMS_FAILED,
      message: e.message,
    });
  }
}

export default function* recommendedYield() {
  yield takeLatest(ActionTypes.GET_RECOMMENDED_ITEMS_REQUESTED, recommended);
}
